import { computed, inject, type Signal } from '@angular/core';

import { AuthenticationService } from '@shared/services/authentication.service';

import { createAccessControl } from './access-control.service';

export const injectCanWrite = (): Signal<boolean> => {
	const authenticationService = inject(AuthenticationService);
	const accessControl = createAccessControl();

	return computed(() => accessControl.setStrategy(authenticationService.user()).canWrite());
};
